import * as Types from "./../constants/TypeActions";

let Initstate = {
    isloading: "",
    title: "",
    keyTabBottom: "Home",
    hiddenTabBottom: false,
};

const reducer = (state = Initstate, action) =>
{
    switch (action.type) {
        case Types.SET_TITLE:
            state = {
                ...state,
                title: action.result,
            };
            return { ...state };
            case Types.SET_KEY_TAB_BOTTOM:
                state = {
                    ...state,
                    keyTabBottom: action.result,
                };
                return { ...state };
                case Types.SET_HIDDEN_TAB_BOTTOM:
                    state = {
                        ...state,
                        hiddenTabBottom: action.result,
                    };
                    return { ...state };
        default:
            return { ...state };


    }
};
export default reducer;
